"use client";

import Footer from "@/app/new-home/new-home-page/src/footer/Footer";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const ListingPageFooter = () => {
  const [isDesktop] = useMediaQuery("(min-width: 1200px)");
  return <>{isDesktop ? <Footer /> : null}</>;
};
export default ListingPageFooter;